module.exports = __webpack_public_path__ + "img/montando-blocos.jpg";